<template>
  <div>
    <b-modal
      hide-footer
      hide-backdrop
      no-close-on-esc
      title="Settings"
      ref="posSettingsModal"
      id="posSettingsModal"
      size="sm"
    >

    <div class="row settings-box mb-4" v-if="USE_TIM_INTEGRATION == 'Y'">
      <div class="col-12 setting-head text-blue border-bottom mb-2 pb-2">
          {{'ECR Settings'}}
        </div>
        <div class="col-12 py-2">
            <div class="row">
              <div class="col-4 d-flex align-items-center fs-11">POS ID:</div>
              <div class="col-8">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="pos_settings.ECR_SETTINGS.pos_id"
                      type="text"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        <div class="col-12 py-2">
            <div class="row">
              <div class="col-4 d-flex align-items-center fs-11">IP Address:</div>
              <div class="col-8">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="pos_settings.ECR_SETTINGS.ecr_ip_address"
                      type="text"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        <div class="col-12 py-2">
            <div class="row">
              <div class="col-4 d-flex align-items-center fs-11">PORT:</div>
              <div class="col-8">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="pos_settings.ECR_SETTINGS.ecr_port"
                      type="text"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
    </div>

    <div class="mb-2" v-if="HARDWARE_SETTING_ON_POS == 'Y' && DeviceUniqueCode">
      <a class="text-primary" style="font-weight: 500; font-size: 13px;" @click="onClickChangePosHardwareSettings()">Change Hardware Settings ></a>
    </div>
    <div class="mb-2" v-if="USE_TIM_INTEGRATION == 'Y'">
      <a class="text-primary" style="font-weight: 500; font-size: 13px;" @click="openEftFunctions()">Tim Terminal Options ></a>
    </div>

    <div class="row settings-box" v-if="!DeviceUniqueCode && USE_TIM_INTEGRATION == 'N' && HARDWARE_SETTING_ON_POS == 'N'">
      <div class="noSettings d-flex align-items-center justify-content-center w-100">
        No Settings Found
      </div>
    </div>
    
    <div class="row">
      <div class="col-12 pt-3 text-center">
        <button v-on:click="saveSettings()" v-if="USE_TIM_INTEGRATION == 'Y'" :class="USE_TIM_INTEGRATION == 'N' ? 'disabled' : ''" class="btn-blue">Save</button>
        <button
          @click.prevent.stop="$bvModal.hide('posSettingsModal')"
          class="btn-blue"
        >
          Cancel
        </button>
      </div>
    </div>

      
    </b-modal>
      <ManagerAuthLogin :moduleName="'pos_Hardware'" :onCheckAuth="onCheckAuthentication" :refId="'authManager_pos_Hardware'" />
      <ManagerAuthLogin :moduleName="'pos_timTerminal'" :onCheckAuth="onCheckAuthentication" :refId="'authManager_pos_timTerminal'" />
     <posHardwarePopup/>
     <EFTFunctionsPopup/>
  </div>
</template>

<script>
import { BASEURL } from "@/config/index.js";
import Nav from "@/Nav";
import MasterService from "@/services/MasterService";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import { backendSocket, EventBus } from "@/main.js";
import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
import posHardwarePopup from "@/components/Partials/PosHardwareSettingsPopup";
import EFTFunctionsPopup from "@/components/Partials/EFTFunctionsPopup.vue";


export default {
  props: {},
  components: {
    Vkeyboard,
    VkeyboardFloat,
    ManagerAuthLogin,
    posHardwarePopup,
    EFTFunctionsPopup
  },
  data() {
    return {
      noAuth: false,
      pos_settings: {
        ECR_SETTINGS: {
          pos_id: 'ECR-01',
          ecr_user_id: null,
          ecr_ip_address: '',
          ecr_port: '80',
          ecr_integralId: '367fcd48-f574-4119-960c-d1ebb00f9a97'
        },
        POS_LOCATION_SETTINGS: {
          selectedLocation: "",
          hardware_location_id: null
        }
      },
      DeviceUniqueCode: null,
      hardware_id: null,
      HardwareLocations: [],
       keyboardsVisible: {
        showFirstNameKeyboard: false,
        showLastNameKeyboard: false,
        showEmailKeyboard: false,
      },
    };
  },
  sockets: {
    hardwareId: function(macId) {
      if (macId) {
        this.hardware_id = macId;
      }
    }
  },
  computed: {
    USE_TIM_INTEGRATION() {
      return this.$store.getters.USE_TIM_INTEGRATION
    },
    MANAGER_AUTH_FOR_CHANGES() {
      return this.$store.getters.MANAGER_AUTH_FOR_CHANGES
    },
     HARDWARE_SETTING_ON_POS() {
      return this.$store.getters.HARDWARE_SETTING_ON_POS
    },
    HARDWARE_LOCATIONS() {
      return this.$store.getters.HARDWARE_LOCATIONS
    },
  },
  beforeMount() {
    if(localStorage.getItem('ECR_INFO')) {
      let ECR_INFO = JSON.parse(localStorage.getItem('ECR_INFO'))
      Object.keys(ECR_INFO).map((x) => {
        this.pos_settings.ECR_SETTINGS[x] = ECR_INFO[x];
      })
    }
    this.DeviceUniqueCode = window.localStorage.getItem("deiviceUniqueCode")
      ? window.localStorage.getItem("deiviceUniqueCode")
      : "";
  },
  mounted() {
  },
  methods: {
    onClickChangePosHardwareSettings() {
      console.log('CLICKED onClickChangePosHardwareSettings');
      this.$bvModal.hide("posSettingsModal");
      if(this.MANAGER_AUTH_FOR_CHANGES == 'Y' && !this.noAuth) {
        console.log('COMING HERE');
        this.$bvModal.show("authManager_pos_Hardware");
      } else {
        // this.$bvModal.hide("posSettingsModal");
        this.$bvModal.hide("authManager_pos_Hardware");
        this.$bvModal.show("posHardwareSettings");
      }
      
    },
    openEftFunctions() {
      console.log('CLICKED openEftFunctions');
      this.$bvModal.hide("posSettingsModal");
      if(this.MANAGER_AUTH_FOR_CHANGES == 'Y' && !this.noAuth) {
        this.$bvModal.show("authManager_pos_timTerminal");
      } else {
        this.$bvModal.hide("authManager_pos_timTerminal");
        this.$bvModal.show("eft_tim_terminal_functions");
      }
      
    },
     onCheckAuthentication(response) {
      const {valid, name} = response
      if(valid) {
        if(name == "pos_Hardware") {
          this.noAuth = true;
          this.$bvModal.hide("authManager_pos_Hardware");
          this.onClickChangePosHardwareSettings();
        } else if(name == "pos_timTerminal") {
          this.noAuth = true;
          this.$bvModal.hide("authManager_pos_timTerminal");
          this.openEftFunctions();
        }
      } 
    },
     onSelectHardwareLocation(event, type = 'select') {
      if(type == 'select') {
        this.pos_settings.POS_LOCATION_SETTINGS.selectedLocation = event;
        this.pos_settings.POS_LOCATION_SETTINGS.hardware_location_id = event.hl_id;
      } else if(type == 'remove') {
        this.pos_settings.POS_LOCATION_SETTINGS.selectedLocation = '';
        this.pos_settings.POS_LOCATION_SETTINGS.hardware_location_id = null;
      }
    },
    saveSettings() {
      let loader = this.$loading.show();
      let payload = JSON.stringify(this.pos_settings.ECR_SETTINGS)
      localStorage.setItem('ECR_INFO', payload);
      let obj = {
        EventBus: EventBus,
        IPADDRESS: this.pos_settings.ECR_SETTINGS.ecr_ip_address,
        PORT: this.pos_settings.ECR_SETTINGS.ecr_port,
        USERID: this.pos_settings.ECR_SETTINGS.ecr_user_id,
        POSID: this.pos_settings.ECR_SETTINGS.pos_id,
        INTEGRATIONID: "367fcd48-f574-4119-960c-d1ebb00f9a97"
      };
      if(typeof initTimApi == 'function' && this.pos_settings.ECR_SETTINGS.ecr_ip_address && this.pos_settings.ECR_SETTINGS.ecr_port) {
        localStorage.setItem('ECR_INIT_STATUS', true)
        initTimApi(obj);
      } else {
        localStorage.setItem('ECR_INIT_STATUS', false)
      }
      // let hardwareObj = {
      //   hardware_location_id: this.pos_settings.POS_LOCATION_SETTINGS.hardware_location_id,
      //   unique_id: this.DeviceUniqueCode
      // }
      // MasterService.UpdatePosHardwareSettings(hardwareObj).then((response) => {
      //   const {data} = response;
      //   console.log('DATA', data);
      //   if(data && data.status) {
      //     if(this.DeviceUniqueCode){
      //       this.$store.dispatch("fetchPosHardwareSettings", this.DeviceUniqueCode);
      //     }
      //     console.log('SUCCESSFULLY SAVED HARDWARE LOCATION');
      //   } else {
      //     console.log('UNABLE TO SAVE HARDWARE LOCATION');
      //   }
      // })

      setTimeout(z => {
        this.$bvModal.hide('posSettingsModal')
        loader.hide();
      }, 1000);
    },
  },
};
</script>
<style>
.disbled-section {
  cursor: not-allowed;
  opacity: 0.4;
}

.settings-box {
  font-size: 12px;
  font-weight: bold;
}
#posSettingsModal___BV_modal_content_ {
  width: 135% !important;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/PosSettingsPopup.vue